module.exports = __webpack_public_path__ + "src/assets/games/19/397.jpg";